"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_paper_1 = require("react-native-paper");
const native_1 = require("@react-navigation/native");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const styles_1 = __importDefault(require("../../styles/styles"));
const typesConstants_1 = require("../../constants/typesConstants");
const schedulesConstants_1 = require("../schedules/schedulesConstants");
const useAppDispatch_1 = __importDefault(require("../../hooks/useAppDispatch"));
const screenConstants_1 = require("../../constants/screenConstants");
const useWebDesktopDesign_1 = __importDefault(require("../../hooks/useWebDesktopDesign"));
const eventConstants_1 = require("../../constants/eventConstants");
const scheduleSlice_1 = require("../schedules/scheduleSlice");
const scheduleComponent_1 = __importDefault(require("../schedules/scheduleComponent"));
const boxTitle_1 = __importDefault(require("../../components/boxTitle/boxTitle"));
const icon_1 = __importDefault(require("../../components/icon/icon"));
const useAppSelector_1 = __importDefault(require("../../hooks/useAppSelector"));
const pressable_1 = __importDefault(require("../../components/pressable/pressable"));
const spinner_1 = __importDefault(require("../../components/spinner/spinner"));
const userScheduleComponent_1 = __importDefault(require("../schedules/userScheduleComponent"));
const callLaterComponent_1 = __importDefault(require("../../components/scheduleAction/callLaterComponent"));
const ScheduleSearchedComponent = () => {
    const dispatch = useAppDispatch_1.default();
    const { loadingStatus, schedule, loan, user } = useAppSelector_1.default((state) => ({
        loadingStatus: state.schedule.status,
        schedule: state.schedule.schedule,
        loan: state.schedule.loan,
        user: state.schedule.user,
    }));
    const navigator = native_1.useNavigation();
    const route = native_1.useRoute();
    const isDesktop = useWebDesktopDesign_1.default();
    let statusText = '';
    const containerStyles = isDesktop ? [styles_1.default.flexDirectionRow] : [];
    react_1.useEffect(() => {
        if (!schedule) {
            dispatch(scheduleSlice_1.getSchedule({ scheduleId: route.params.schedule_id }));
        }
    }, []);
    react_1.useEffect(() => {
        if (!schedule)
            return;
        const isUserSchedule = schedule.external_id_type === typesConstants_1.EXTERNAL_ID_TYPE_USER;
        const missingData = (isUserSchedule && !user) || (!isUserSchedule && !loan);
        if (missingData) {
            dispatch(scheduleSlice_1.getScheduleCustomerData({ scheduleId: schedule.id }));
        }
    }, [schedule, loan, user]);
    if (schedule) {
        if (schedule.status === schedulesConstants_1.SCHEDULE_STATUS_COMPLETED) {
            statusText = 'Completed';
        }
        else if (schedule.status === schedulesConstants_1.SCHEDULE_STATUS_CANCELED) {
            statusText = 'Canceled';
        }
        else if (schedule.status === schedulesConstants_1.SCHEDULE_STATUS_RESCHEDULED) {
            statusText = 'Rescheduled';
        }
        else if (schedule.status === schedulesConstants_1.SCHEDULE_STATUS_NOT_STARTED) {
            statusText = 'Not started';
        }
        else if (schedule.status === schedulesConstants_1.SCHEDULE_STATUS_STARTED) {
            statusText = 'Started';
        }
        const navigateHandler = async () => {
            await dispatch(scheduleSlice_1.resetScheduleState());
            navigator.navigate(screenConstants_1.DASHBOARD_SCREEN);
        };
        const pageContent = (react_1.default.createElement(react_native_1.View, { style: containerStyles },
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.marginTen] },
                react_1.default.createElement(boxTitle_1.default, { title: `${schedule.partner_name} Schedule` }),
                react_1.default.createElement(react_native_1.Text, null, statusText),
                react_1.default.createElement(react_native_1.Text, null, schedule.id)),
            react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterEnd, styles_1.default.flexOne] },
                react_1.default.createElement(react_native_1.View, { style: containerStyles },
                    react_1.default.createElement(react_native_1.View, { style: [styles_1.default.alignCenterStart, styles_1.default.marginTen] },
                        react_1.default.createElement(callLaterComponent_1.default, { schedule: schedule })),
                    react_1.default.createElement(pressable_1.default, { onPress: navigateHandler, style: [styles_1.default.flexDirectionRow, styles_1.default.alignCenterCenter], eventName: eventConstants_1.NAVIGATE_DASHBOARD_BUTTON },
                        react_1.default.createElement(react_native_1.View, null,
                            react_1.default.createElement(icon_1.default, { icon: free_solid_svg_icons_1.faArrowLeft })),
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.marginTen },
                            react_1.default.createElement(react_native_paper_1.Title, { style: styles_1.default.textColorBlue }, ` Dashboard `)))))));
        const content = schedule.external_id_type === typesConstants_1.EXTERNAL_ID_TYPE_USER ? (react_1.default.createElement(userScheduleComponent_1.default, { loadingStatus: loadingStatus, schedule: schedule, user: user, pageContent: pageContent, displayActions: true })) : (react_1.default.createElement(scheduleComponent_1.default, { schedule: schedule, loan: loan, loadingStatus: loadingStatus, pageContent: pageContent }));
        return content;
    }
    return react_1.default.createElement(spinner_1.default, null);
};
exports.default = ScheduleSearchedComponent;
